import { useState, Suspense } from 'react'
import { useRouteLoaderData } from 'react-router'
import { BranchPageHeading } from '~/components/subscription/branch-page-heading'
import { Panel } from '~/components/subscription/panel'
import { CreditCardForm } from '@/components/subscription/branch-checkout/credit-card-form'
import { Card } from '@/api-client/data-contracts'

const creditCardPromise = Promise.resolve(null)

export const SubscriptionRoseMypageCard: React.FC = () => {
  const {
    data: { data: account },
  } = useRouteLoaderData('mypageLayout')

  const [creditCard, setCreditCard] = useState<Card | null>(null)
  const [holderName, setHolderName] = useState('')
  const [numberElement, setNumberElement] = useState(null)
  const [email, setEmail] = useState(account ? account.attributes.email : '')

  const handleUpdateCard = ({ holderName, numberElement }) => {
    setHolderName(holderName)
    setNumberElement(numberElement)
  }

  const handleSubmit: React.MouseEventHandler<HTMLButtonElement> = async () => {
    window.payjpInstance ||= window.Payjp(window.payjpPublicKey, { threeDSecureWorkflow: 'redirect' });

    try {
      const res = await window.payjpInstance.createToken(numberElement, {
        three_d_secure: true,
        card: { email, name: holderName },
      })

      if ('id' in res) {
        const formData = new FormData()
        formData.append('card_token', res.id)

        const response = await window.fetch(`/cards?next=${encodeURIComponent('/subscription/rose/mypage')}`, {
          method: 'POST',
          body: formData,
          credentials: 'include',
          headers: {
            'X-CSRF-Token': (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement).content,
          },
        })
        const { tds_url } = await response.json()

        location.href = tds_url
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <form className="w-full space-y-8 pt-4 pb-18">
      <BranchPageHeading main="クレジットカードの変更" />
      <Panel padding="m">
        <div>
          <Suspense fallback={<></>}>
            <CreditCardForm gap="s" creditCard={creditCardPromise} onInitialized={setCreditCard} onUpdate={handleUpdateCard} />
          </Suspense>
        </div>
      </Panel>
      <button
        type="button"
        className="w-full py-5 bg-black text-white text-[15px] font-medium rounded-full hover:bg-main transition-colors cursor-pointer"
        onClick={handleSubmit}
      >
        保存する
      </button>
    </form>
  )
}
